<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout wrap justify-center align-end>
      <v-flex v-for="(text,i) in textos" :key="'text'+i" class="xs12 md4">
        <v-layout wrap justify-center class="item-container">
          <p v-if="vistos[i]" class="bubble animated fadeIn">{{text}}</p>
          <div class="text-xs-center">
            <button @click="$set(vistos,i,true)" class="image-button hvr-shrink"><img :src="require('../../assets/presentacion/diapositiva-4-'+ (i + 1) +'.png')" :alt="titulos[i]"></button>
            <p aria-hidden class="flex xs12 button-title">{{titulos[i]}}</p>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Presentacion/AUDIO 06'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "¡Última noticia! Ecopetrol S.A ha presentado su informe anual de reservas. Esto ha causado diferentes impresiones en torno a nuestra compañía, <span class='instruccion'>haz clic en cada perfil.</span>" 
      ],
      titulos: [
        "Inversionista",
        "Ejecutivo del sector financiero",
        "Gobierno",
        "Empresas",
        "Empleado operario"
      ],
      textos: [
        "¿Y será que esto afecta las acciones?",
        "Lo estaba esperando, éste será el tema principal para la próxima reunión con mi equipo de crédito de inversión.",
        "Ahora sí podemos asegurar la inversión social.",
        "Esto nos da una perspectiva real en las proyecciones de nuestros presupuestos.",
        "¿Reservas? ¿Y eso, qué tiene que ver con la empresa?"
      ],
      vistos: Array(5).fill(false)
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(value) {
      var todosVistos = value.every(el => {return el})
      if (todosVistos) {
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.image-button{
  max-width: 175px;
}

.button-title {
  text-align: center;
  font-weight: bold;
  font-family: HelveticaNeueCn;
  font-size: 1.2em;
}

.bubble {
  background-color: white;
  color: black;
  padding: 10px;
  margin: 10px;
  margin-bottom: 20px;
  position: relative;
  &::after {
    // Flecha
    content: " ";
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border: 15px solid transparent;
    border-top-color: white;
    bottom: -30px;
    left: calc(50% - 10px);
  }
}
</style>
